<template>
  <div>
    <ThreeTest id='threeTest' ref="threeTest" :productInfo='productInfo' v-show="isModel"></ThreeTest>
    <!-- <div class="bgpos"></div> -->
    <div class="contentBox">
      
      <div class="navBox leftBtn" v-show="menuIsShow" v-if="btnmenuShow">
          <div class="infolist" v-for="(item,key) in childInfos" :key="key" @click="introduceShow(key)">{{item[0]}}
            <div class="txtBox Animation scrollBox" v-show="introduceIsShow===key" v-html="item[1]"></div>
          </div>
      </div>
      <div :class="{btnmenu: true, active: !menuIsShow}" v-if="btnmenuShow" @click="menuShow"><img :src="$baseURL + btnhicon" alt=""></div>
      <div class="morebtn" v-if="morebtnShow" @click="tvShow"><img :src="$baseURL + iconvvideo" alt=""></div>
      <div class="companyBox">
          <div class="nameinfo">
              {{company}}<br/>{{name}}
          </div>
      </div>
      
    </div>  
    <div class="posBox" v-if="tvIsShow">
        <div class="listvideoBox">
            <div class="close" @click="tvShow" v-if="closeBtnShow"></div>
            <div class="videonameBox scrollBox">
                <div :class="{active: tvActive}" @click="changTV(videos['start'][1],0)">{{videos['start']&&videos['start'][0]}}</div>
                
            </div>
            <div class="videolist">
                <video width="100%" height="100%" loop muted controls autoplay ref="video" style="object-fit:fill">
                    <source ref="source" :src="tvSrc" type="video/mp4" >
                </video>
            </div>
            
        </div>
        <div v-if="videoBtnShow" class="videoBtn">
          <el-button :type="tvBtnType1" icon="el-icon-video-camera" style="font-size:20px; opacity: 0.9;" @click="changTV(videos['company'][1],1)">{{videos['company'] && videos['company'][0]}}</el-button>
          <el-button :type="tvBtnType3" icon="el-icon-video-camera" style="font-size:20px; opacity: 0.9;" v-show="endBtnShow"  @click="changTV(videos['ending'][1],3)">{{videos['ending'] && videos['ending'][0]}}</el-button>
          <el-button :type="tvBtnType2" icon="el-icon-video-camera" style="font-size:20px; opacity: 0.9;" @click="changTV(videos['achievement'][1],2)">{{videos['achievement'] && videos['achievement'][0]}}</el-button>
          
        </div>
        
    </div>  
  </div>
</template>

<script>
import ThreeTest from './3D/Scene3D';
export default {
  name: 'Product',
  components: { 
      ThreeTest
   },
  data() {
    return {
      content1: 'content1',
      content2: 'content2',
      content3: 'content3',
      content4: 'content4',
      tvBtnType1: 'primary',
      tvBtnType2: 'primary',
      tvBtnType3: 'primary',
      iconvvideo: 'image/iconvvideo.png',
      btnhicon: 'image/btnhicon.png',
      productInfo: [],
      menuIsShow: true,
      introduceIsShow: '',
      menuActive: false,
      childInfos: {},
      company: '',
      name: '',
      tvIsShow: false,
      videos: {},
      videoName: '',
      videoUrl: '',
      tvActive: true,
      tvSrc: '',
      btnmenuShow: true,
      morebtnShow: true,
      isModel: true,
      videoBtnShow: false,
      endBtnShow: false,
      closeBtnShow: true,
    };
  },
  created() {
    
  },
  methods: {
    introduceClose(){
      this.introduceIsShow = '';
      

    },
    changTV(url, type){
      this.tvBtnType1 = 'primary';
      this.tvBtnType2 = 'primary';
      this.tvBtnType3 = 'primary';
      if(type === 1){
        this.tvBtnType1 = 'success';
        this.endBtnShow = true;
        this.tvActive = false;
      }else if(type === 2){
        this.tvBtnType2 = 'success';
        this.endBtnShow = true;
        this.tvActive = false;
      }else if(type === 3){
        this.tvBtnType3 = 'success';
        this.tvActive = false;
      }else{
        this.tvActive = true;
      }
      
      console.log(this.$refs.video);
       
      this.tvSrc = this.$baseURL + url;
      console.log(this.tvSrc);
      
      this.$refs.video.load();
      this.$refs.video.play();
      

    },
    introduceShow(key){
      this.tvIsShow = false;
      this.introduceIsShow = key;

    },
    tvShow(){
      this.introduceIsShow = '';
      this.tvIsShow = !this.tvIsShow;
    },
    menuShow(){
      this.introduceIsShow = '';
      // this.tvIsShow = false;
      this.menuIsShow = !this.menuIsShow;
    }
  },
  
  beforeRouteEnter(to, from, next){
    next(vm=>{
      let id = to.params.id;
      console.log('id', to);
      vm.$axios.get(vm.$baseURL + 'data/productData.json')
      .then(res => {

          let productInfos = res.data;
          vm.productInfo = [];
          vm.productInfo.push(productInfos[id-1]);
          
          vm.Event.$emit('load', true);
          vm.Event.$emit('bgtv', 'video/73.mp4');
          vm.Event.$emit('goHomeShow', true);
          console.log('vm.productInfo', vm.productInfo);
          let type = vm.productInfo[0].type;
          
          
          vm.childInfos = vm.productInfo[0].childInfo;
          if(!vm.productInfo[0].childInfo){
            vm.btnmenuShow = false;
          }else{
            vm.btnmenuShow = true;
            
          }
          vm.company = vm.productInfo[0].company;
          vm.name = vm.productInfo[0].name;
          vm.videos = vm.productInfo[0].video;
          // if(!vm.productInfo[0].video){
          //   vm.morebtnShow = false;
          // }else{
          //   vm.morebtnShow = true;
          //   vm.tvActive = true;
          //   vm.tvSrc = vm.$baseURL + vm.videos['start'][1];
            
          // }
          
          if(type === 'model'){
            vm.videoBtnShow = false;
            vm.isModel = true;
            vm.tvIsShow = false;
            vm.closeBtnShow = true;
            if(vm.productInfo[0].video){
              vm.morebtnShow = true;
              if(vm.$refs.video){
                vm.$refs.video.load();
                vm.$refs.video.play();
              }
              
              console.log(222);
              vm.tvSrc = vm.$baseURL + vm.videos['start'][1];

            }else{
              vm.morebtnShow = false;
            }
            
          }else{
            console.log(111);
            vm.videoBtnShow = true;
            vm.isModel = false;
            vm.Event.$emit('load', false);
            vm.tvIsShow = true;
            vm.closeBtnShow = false;
            vm.morebtnShow = false;
            
            vm.tvSrc = vm.$baseURL + vm.videos['start'][1];
            if(vm.$refs.video){
              vm.$refs.video.load();
              vm.$refs.video.play();
            }
            
          }
      })
    });
    },
  beforeRouteUpdate(to, from, next){
    next();
    },
  beforeRouteLeave(to, from, next){
    this.introduceIsShow = '';
    this.tvIsShow = false;
    this.tvActive = true;
    this.tvSrc = '';
    next();
    this.Event.$emit('bgtv', 'video/154.mp4');
    this.endBtnShow = false;
    this.tvBtnType1 = 'primary';
    this.tvBtnType2 = 'primary';
    this.tvBtnType3 = 'primary';
    },
};
</script>
<style scoped>
  
</style>